export const CHART_MARGIN = {left: 64, top: 24, bottom: 56, right: 32} as const

export function getChartNow() {
  const now = new Date()
  // Add 1 hour to now to show future predictions
  now.setHours(now.getHours() + 1)
  return now
}
